<template>
    <span v-if="mensagem.status == 0">
        <b-button
            variant="success"
            @click.stop="confirmarEnviar()"
            class="float-right ml-2"
            :disabled="desabilitarEnviar"
        >
            <span> <i class="fa fa-paper-plane-o"></i> Enviar </span>
        </b-button>
    </span>
</template>

<script>
import MensagensServicos from './MensagensServicos'

export default {
    props: {
        mensagem: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarEnviar() {
            this.$swal({
                title: 'Enviar Mensagem',
                html: `Confirma o envio da mensagem?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.enviar()
                }
            })
        },

        enviar() {
            this.$store.dispatch('addRequest')
            let mensagemDto = {
                assunto: this.mensagem.assunto,
                conteudo: this.mensagem.conteudo
            }
            if (this.mensagem.mensagemId) {
                mensagemDto.mensagemId = this.mensagem.mensagemId
            }
            if (!this.$store.getters.isFornecedor) {
                mensagemDto.destinatarios = this.mensagem.destinatarios
            }
            MensagensServicos.enviarMensagem(mensagemDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Mensagem salva com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterMensagensAtualizadas')
                        this.$router.push({ name: 'Mensagens' })
                    } else {
                        this.$toast.error(
                            'Erro ao enviar mensagem!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        desabilitarEnviar() {
            if (
                this.mensagem.assunto.length > 0 &&
                this.mensagem.conteudo.length > 0
            )
                return false
            return true
        }
    },

    watch: {},

    validations: {}
}
</script>
